// extracted by mini-css-extract-plugin
export default {"container":"inviteLayout_container__AW+ox","content":"inviteLayout_content__qgQ46","logo":"inviteLayout_logo__+H2N3"};